import { Attachment } from "./Attachment";
import { Category } from "./Category";

export interface Question {
  _id?: string;
  title?: string;
  difficulty?: string;
  category?: Category;
  attachment?: Attachment;
  answerTitle?: string;
  createdAt?: Date;
}

export interface FilterByCategoriesSubcategories {
  categoryId: string;
  subcategories: Array<string>;
}

export interface Answer {
  _id?: string;
  question?: Question;
  title?: string;
  attachment?: Attachment;
}

export enum Difficulty {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARD = "Hard",
}
